import { forwardRef } from 'react';

import { AlertTriangle } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/atoms/Tooltip';

interface DiarizationCorrectionIndicatorProps {
  correctionId: string;
  confidence: number;
  onClick?: () => void;
}

export const DiarizationCorrectionIndicator = forwardRef<HTMLButtonElement, DiarizationCorrectionIndicatorProps>(
  ({ correctionId, confidence, onClick }, ref) => {
    const getIndicatorColor = (confidence: number) => {
      if (confidence >= 0.9) return 'text-red-500 bg-red-50 border-red-200';
      if (confidence >= 0.8) return 'text-orange-500 bg-orange-50 border-orange-200';
      return 'text-yellow-500 bg-yellow-50 border-yellow-200';
    };

    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            ref={ref}
            onClick={onClick}
            className={`inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs transition-all hover:shadow-sm ${getIndicatorColor(
              confidence,
            )}`}
            data-testid={`correction-indicator-${correctionId}`}
          >
            <AlertTriangle className="h-3 w-3" />
            <span className="font-medium">Possible Correction</span>
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Possible correction detected</p>
          <p className="text-xs opacity-75">Click to review</p>
        </TooltipContent>
      </Tooltip>
    );
  },
);

DiarizationCorrectionIndicator.displayName = 'DiarizationCorrectionIndicator';
